import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_auto_email_eligible_shipmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { type_id?: number, projectId?: number, from_date?: string, $top?: number, $skip?: number }): Promise<{ result?: { shipment_id?: number, lookup_code?: string, warehouse_id?: number }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { type_id?: number, projectId?: number, from_date?: string, $keys: number[] }): Promise<{ result?: { shipment_id?: number, lookup_code?: string, warehouse_id?: number }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      type_id?: number, projectId?: number, from_date?: string    }) {
      return false;
    }
}
